import { createSlice } from "@reduxjs/toolkit";

export const loginForTestEnv = createSlice({
    name: 'loginForTestEnv',
    initialState: {
        currentUser: undefined,
        isAutorized: sessionStorage.getItem("isAutorized")
    },
    reducers: {
        setCurrentUser(state, action) {
            state.currentUser = action.payload;
            state.isAutorized = true
            sessionStorage.setItem("isAutorized", true)
        },
    }
})

export const { setCurrentUser } = loginForTestEnv.actions;
export default loginForTestEnv.reducer;